import React from "react";
import { Users, Package, BookOpen } from "react-feather";

const Transformation = () => {
	return (
		<section className="bg-gray-50 py-6 sm:py-10 lg:py-[5rem] px-6">
			<div className="container">
				<div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-[5rem]">
					{/* Left Side - Heading */}
					<div className="text-left lg:text-left">
						<h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-light text-swift-dark leading-tight font-generalSans">
							A New Era of Menstrual Health Equity one{" "}
							<span className="text-swift-pink">
								cycle at a time
							</span>
						</h2>
					</div>

					{/* Right Side - Impact Metrics */}
					<div className="grid grid-cols-2 lg:flex lg:flex-row gap-4 sm:gap-6 lg:gap-[3rem]">
						{/* Girls Reached */}
						<div className="text-center">
							<div className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2 sm:mb-3 bg-gray-200 rounded-full flex items-center justify-center">
								<Users className="w-5 h-5 sm:w-6 sm:h-6 text-swift-dark" />
							</div>
							<div className="text-swift-dark">
								<div className="text-sm sm:text-base lg:text-l mb-1 font-generalSans font-light">
									<span className="font-light text-swift-pink">
										500+
									</span>{" "}
									Girls Reached & Educated
								</div>
							</div>
						</div>

						{/* Pads Distributed */}
						<div className="text-center">
							<div className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2 sm:mb-3 bg-gray-200 rounded-full flex items-center justify-center">
								<Package className="w-5 h-5 sm:w-6 sm:h-6 text-swift-dark" />
							</div>
							<div className="text-swift-dark">
								<div className="text-sm sm:text-base lg:text-l mb-1 font-generalSans font-light">
									<span className="font-light text-swift-pink">
										1500+
									</span>{" "}
									Pads Distributed
								</div>
							</div>
						</div>

						{/* Schools Reached */}
						<div className="text-center col-span-2 lg:col-span-1 lg:col-start-3">
							<div className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2 sm:mb-3 bg-gray-200 rounded-full flex items-center justify-center">
								<BookOpen className="w-5 h-5 sm:w-6 sm:h-6 text-swift-dark" />
							</div>
							<div className="text-swift-dark">
								<div className="text-sm sm:text-base lg:text-l mb-1 font-generalSans font-light">
									<span className="font-light text-swift-pink">
										Over 4
									</span>{" "}
									Schools reached
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Transformation;
